export default __webpack_public_path__ + "static/ActaAgate-Book-6a7352d42a7b54544cc4de5fd6954118.woff2";